/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { SpecimenProtocolOverride } from "./SpecimenProtocolOverride";

export type SpecimenPATCH = {
    /**
     * name of the specimen group, should match slide block
     */
    name: string;
    /**
     * Final gross description
     */
    gross_description?: string | null;
    /**
     * Changing clinical history may also change protocols
     */
    clinical_history?: string | null;
    site?: string | null;
    /**
     * what is the source for the specimen
     */
    type?: SpecimenPATCH.type | null;
    procedure?: SpecimenPATCH.procedure | null;
    protocol_overrides?: Array<SpecimenProtocolOverride>;
    source?: string | null;
    lis_state?: SpecimenPATCH.lis_state | null;
    /**
     * Using text editing instead of Grossing Mad-Lib?
     */
    grossing_raw_text?: boolean;
    /**
     * Modifier selections for Grossing Mad-Lib
     */
    grossing_modifier_selections?: any;
    /**
     * Token selections for Grossing Mad-Lib
     */
    grossing_token_selections?: any;
    /**
     * LabStain selections for Grossing Mad-Lib. Should only be used for Specimen Protocols.
     */
    grossing_lab_stain_selections?: Array<number> | null;
    /**
     * LabPanel selections for Grossing Mad-Lib. Should only be used for Specimen Protocols.
     */
    grossing_lab_panel_selections?: Array<number> | null;
    slow_mohs_source_id?: number;
}

export namespace SpecimenPATCH {

    /**
     * what is the source for the specimen
     */
    export enum type {
        MUCOSA = 'MUCOSA',
        SKIN = 'SKIN',
        NAIL = 'NAIL',
        SOFT_TISSUE = 'SOFT TISSUE',
        OTHER = 'OTHER',
        UNKNOWN = 'UNKNOWN',
    }

    export enum procedure {
        C = 'c',
        E = 'e',
        PE = 'pe',
        IB = 'ib',
        NC = 'nc',
        NA = 'na',
        PB = 'pb',
        SB = 'sb',
        SBD = 'sbd',
        SCE = 'sce',
        SR = 'sr',
        SRD = 'srd',
        SNB = 'snb',
        GR = 'gr',
        SE = 'se',
        EBX = 'ebx',
        FB = 'fb',
        MOHS = 'mohs',
        DBLK = 'dblk',
        U = 'u',
        O = 'o',
    }

    export enum lis_state {
        BOTTLED = 'bottled',
        RECEIVED = 'received',
        GROSSED = 'grossed',
    }


}
